module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "platform-stats"
  }, [_vm._m(0), _c('div', {
    staticClass: "stats-item"
  }, [_c('div', {
    class: {
      'animate': _vm.totalChanged
    }
  }, [_c('div', {
    staticClass: "c-1 indicator hint--bottom",
    attrs: {
      "aria-label": "Paid across all assets"
    }
  }), _c('span', {
    staticClass: "amount"
  }, [_vm._v(_vm._s(_vm._f("thousandComma")(_vm.totalPaid)) + " ")]), _c('span', [_vm._v("BTC paid to miners")])]), _c('div', {
    class: {
      'animate': _vm.totalChanged
    }
  }, [_c('div', {
    staticClass: "c-2 indicator hint--bottom",
    attrs: {
      "aria-label": "Paid across all assets"
    }
  }), _c('span', {
    staticClass: "amount"
  }, [_vm._v(_vm._s(_vm._f("thousandComma")(_vm.totalWorkers)) + " ")]), _c('span', [_vm._v("Past 24hr active workers")])]), _c('div', {
    class: {
      'animate': _vm.totalChanged
    }
  }, [_c('div', {
    staticClass: "c-3 indicator hint--bottom",
    attrs: {
      "aria-label": "Paid across all assets"
    }
  }), _c('span', {
    staticClass: "amount"
  }, [_vm._v(_vm._s(_vm._f("thousandComma")(_vm.totalMiners)) + " ")]), _c('span', [_vm._v("Past 24hr active miners")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fs-16 text-white-on-dark pb-5"
  }, [_c('b', [_vm._v("Pool Stats")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0fd211a9","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/c_platform_stats.vue
// module id = 359
// module chunks = 1